'use strict';

import ngResource from 'angular-resource';

class DailyWeatherService {
  constructor($resource) {
    'ngInject';

    this.api = $resource(
      '/api/daily_weather',
      {},
      { index: {method: 'GET', isArray: true} }
    );
  }
}

export default angular.module('leptonApp.DailyWeatherService', ['ngResource'])
  .service('DailyWeatherService', ['$resource', DailyWeatherService])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/daily_weather/daily_weather.service.js